import React from 'react';
import { CtaButton } from './CtaButton';
import { heroPills } from '../data/content';
export function Hero() {
  return <header className="relative overflow-hidden bg-navy-800 px-5 pb-10 pt-7 sm:pb-12 sm:pt-9" data-id="element-111" data-mp="ej4lxsz4c3dc">
      <div className="mx-auto max-w-4xl text-center" data-id="element-112" data-mp="9luxogngtxr3">
        <p className="inline-flex items-center rounded-full border border-gold/40 bg-gold/10 px-3.5 py-1 text-[10px] font-bold uppercase tracking-[0.16em] text-gold sm:text-[11px]" data-id="element-113" data-mp="4lqjwydxzh4k">
          🏏 The #1 Planning System For Cricket Coaches
        </p>

        <h1 className="mx-auto mt-4 max-w-2xl font-display text-[28px] font-black leading-[1.08] text-white sm:text-4xl lg:text-[44px]" data-id="element-114" data-mp="xbpbp1jitscx">
          Plan Your Entire Cricket Season{' '}
          <span className="text-gold" data-id="element-115" data-mp="nb6ktmtjhbli">In Under 5 Minutes.</span>
        </h1>

        <p className="mx-auto mt-3.5 max-w-xl text-sm leading-relaxed text-white/70 sm:text-base" data-id="element-116" data-mp="3d21rzwjzqin7">
          The complete cricket coaching bible — 50 full sessions, 60+ drills,
          annual planning, batting, bowling, fielding progressions, tactics and
          more. Everything done for you.
        </p>

        <ul className="mx-auto mt-4 flex max-w-2xl flex-wrap items-center justify-center gap-1.5" data-id="element-117" data-mp="3o7vj9hzbpjw8">
          {heroPills.map(pill => <li key={pill} className="rounded-full border border-grass/40 bg-grass/10 px-3 py-1 text-[11px] font-semibold text-grass sm:text-xs" data-id="element-118" data-mp="39a36uyp2pbm9">
              ✅ {pill}
            </li>)}
        </ul>

        <div className="mx-auto mt-5 max-w-lg lg:max-w-xl" data-id="element-119" data-mp="3599jc6fjlytw">
          <img src="https://cdn.magicpatterns.com/uploads/d5VnoaWFVzRAX1jKigv6n6/ChatGPT_Image_20_sept_2026,_22_23_57-Photoroom.png" alt="The complete Cricket Ready system: six coaching manuals, the drill library on tablet, coaching tools on mobile and the full course on laptop" className="h-auto w-full" width={1456} height={1092} data-id="element-120" data-mp="35audhuxy3fr8" />
        </div>

        <div className="mx-auto mt-4 max-w-sm" data-id="element-121" data-mp="s21hwapu6bzg">
          <CtaButton size="md" data-id="element-122" data-mp="s2tdvmncibq9" />
        </div>

        <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-white/50" data-id="element-123" data-mp="nbbev44vul7x">
          <span data-id="element-124" data-mp="ibgmew5glnkr">🔒 Secure Payment</span>
          <span data-id="element-125" data-mp="ichyn3y7og42">⚡ Instant Access</span>
          <span data-id="element-126" data-mp="ddf2ya44fm8r">🛡️ 7-Day Guarantee</span>
        </div>
      </div>
    </header>;
}